import React from "react";

class Feedback extends React.Component {
  render() {
    return (
      // modal-react DIV STARTS HERE
      <div
        className="modal-react counsellor-apt-modal"
        id="modal"
        tabIndex={0}
        style={{
          width: "518px !important",
          margin: "134px auto",
          backgroundColor: "#fff",
        }}
      >
        <span
          onClick={this.props.feedbackModal}
          className="close-button topright"
        >
          <i className="fa fa-times" aria-hidden="true"></i>
        </span>
        {/* cpmtemt DIV STARTS HERE */}
        <div className="content">
          {/* table STARTS HERE */}
          <table className="table borderless table-responsive w-100 d-block d-md-table">
            <tbody className="text-center tableBody">
              <tr>
                <td className="td-no-border feedback-heading pt-40 fw-500">
                  {this.props.FEEDBACK_HEADING}
                </td>
              </tr>
              <tr>
                <td
                  colSpan="3"
                  className="swal2-content td-no-border"
                >
                  <p className="swal2-content">{this.props.FEEDBACK_TEXT}</p>
                </td>
              </tr>
              <tr>
                <td colSpan={3} className="td-no-border">
                  <button
                    type="button"
                    className="swal2-confirm modal-buttons"
                    aria-label=""
                    id="btnViewSlots"
                    onClick={this.props.openUrl}
                    style={{
                      padding: "0.400em 1em !important",
                      display: "inline-block",
                      backgroundColor: "rgb(54, 166, 146)",
                      padding: "10px 20px",
                    }}
                  >
                    {this.props.FEEDBACK_BTN_TEXT}
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
          {/* table ENDS HERE */}
        </div>
        {/* content DIV ENDS HERE */}
      </div> // modal-react DIV ENDS HERE
    );
  }
}

export default Feedback;



// WEBPACK FOOTER //
// ./src/components/Feedback/feedback.js